import {AfterViewInit, Component, Input, OnInit} from '@angular/core'
import {InstagramService} from 'dmmp-services'
import {concatMap, tap} from 'rxjs/operators'
import {EMPTY, from} from 'rxjs'

declare var instgrm
declare var FB: any

@Component({
  selector: 'dmmp-website-social-network-cards',
  templateUrl: './website-social-network-cards.component.html'
})
export class WebsiteSocialNetworkCardsComponent implements OnInit, AfterViewInit {
  @Input() module
  @Input() identifier
  responseDataInstagram = []

  constructor(private instagramService: InstagramService) {
  }

  ngOnInit() {
    if (this.module?.social_network_card?.length > 0) {
      from(this.module?.social_network_card).pipe(
        concatMap((data: any) => {
          if (data?.social_network_type === 'instagram') {
            if (data?.links?.length > 0) {
              return from(data?.links)
                .pipe(
                  concatMap(((res: any) => {
                      return this.instagramService.getInfoVideo(res.value).pipe(
                        tap((response) => {
                          this.responseDataInstagram.push(response)
                        }))
                    })
                  ))
            }
          } else {
            return EMPTY
          }
        })
      ).subscribe()
    }
  }

  executeProcess() {
    instgrm.Embeds.process()
    return true
  }

  ngAfterViewInit() {
    if (FB != null && FB.XFBML != null) {
      FB.XFBML.parse()
    }
    let ngJs: any
    const ngFjs = document.getElementsByTagName('script')[0]
    const ngP = 'https'
    if (!document.getElementById('twitter-wjs')) {
      ngJs = document.createElement('script')
      ngJs.id = 'twitter-wjs'
      ngJs.src = ngP + '://platform.twitter.com/widgets.js'
      ngFjs.parentNode.insertBefore(ngJs, ngFjs)
    }
  }

}
